import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DEFAULT_MODAL } from '../../../constants/userNotificationModalComponentTypes';
import DefaultModal from './DefaultModal';
import { getUserNotificationModal } from '../../UserNotifications/ducks/selectors';
import { userNotificationOperations } from '../../UserNotifications/ducks';

const bannerComponentTypeMapping = {
  [DEFAULT_MODAL]: DefaultModal
};

class UserNotificationModal extends React.Component {
  dismissModal = () => {
    const { userNotificationModal, dismissUserNotification } = this.props;
    return dismissUserNotification(userNotificationModal.notificationId);
  };

  render() {
    const { userNotificationModal } = this.props;
    const { componentType } = userNotificationModal;
    const Modal = bannerComponentTypeMapping[componentType];
    if (!Modal) return null;

    return (
      <Modal userNotification={userNotificationModal} dismissUserNotification={this.dismissModal} />
    );
  }
}

UserNotificationModal.propTypes = {
  dismissUserNotification: PropTypes.func.isRequired,
  userNotificationModal: PropTypes.shape({})
};

UserNotificationModal.defaultProps = {
  userNotificationModal: null
};

const mapStateToProps = state => {
  return {
    userNotificationModal: getUserNotificationModal(state)
  };
};

const mapDispatchToProps = {
  dismissUserNotification: userNotificationOperations.dismissUserNotification
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserNotificationModal);
